import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { listMyCertificates } from "@/lib/journey.functions";
import { Card } from "@/components/ui/card";
import { Award, ExternalLink } from "lucide-react";

export const Route = createFileRoute("/_authenticated/journey/certificates")({
  component: CertificatesPage,
});

function CertificatesPage() {
  const load = useServerFn(listMyCertificates);
  const [items, setItems] = useState<Awaited<ReturnType<typeof listMyCertificates>>>([]);
  useEffect(() => { load().then(setItems).catch(() => setItems([])); }, [load]);
  return (
    <div className="space-y-4">
      {items.length === 0 && <p className="text-sm text-foreground/60">No certificates yet. Complete a challenge or journey to earn one.</p>}
      <ul className="grid gap-4 md:grid-cols-2">
        {items.map((c) => (
          <li key={c.id}>
            <Card className="p-5">
              <div className="flex items-start gap-3">
                <Award className="mt-1 text-gold" size={22} />
                <div className="flex-1">
                  <div className="font-serif text-lg text-gold-luminous">{c.program_title}</div>
                  <div className="text-xs uppercase tracking-widest text-foreground/50">{c.program_kind}</div>
                  <div className="mt-1 text-sm">Issued to {c.recipient_name} · {new Date(c.issued_on).toLocaleDateString()}</div>
                  <div className="mt-1 text-xs text-foreground/50">Verification: <span className="font-mono">{c.verify_code}</span></div>
                  <Link to="/verify/$code" params={{ code: c.verify_code }} className="mt-2 inline-flex items-center gap-1 text-sm text-gold underline underline-offset-4">
                    Public verify page <ExternalLink size={12} />
                  </Link>
                </div>
              </div>
            </Card>
          </li>
        ))}
      </ul>
    </div>
  );
}
